import { Component } from '@angular/core';

@Component({
  selector: 'app-pages-error-404-content',
  templateUrl: './pages-error-404-content.component.html',
  host: {'class': 'w-100 d-flex align-items-center'}
})
export class PagesError404ContentComponent {}
